import type { AmmunitionDefinition } from '../types/ammunition';

/**
 * Registry of all 9 unusual ammunition types from Rogue Trader Core Rulebook
 * Chapter 05 (Table 5–11). Each entry references weapon source IDs from items.json.
 */
export const UNUSUAL_AMMUNITION: AmmunitionDefinition[] = [
  {
    id: 'amputator-shells',
    name: 'Amputator Shells',
    rulebook: 'rogue-trader-core',
    availability: 'Extremely Rare',
    compatibleWeapons: [
      'stub-revolver',
      'stub-auto',
      'shotgun',
      'pump-action-shotgun',
      'combat-shotgun',
      'hand-cannon',
      'autopistol',
      'autogun'
    ],
    effects: {
      damageModifier: 2
    }
  },
  {
    id: 'bleeder-rounds',
    name: 'Bleeder Rounds',
    rulebook: 'rogue-trader-core',
    availability: 'Rare',
    compatibleWeapons: ['stub-revolver', 'stub-auto', 'hand-cannon', 'autopistol', 'autogun'],
    effects: {
      damageModifier: 3,
      conditionalEffects: [
        {
          condition: 'Target does not have Daemonic or Machine Trait',
          effect: '+3 Damage (biological targets only)',
          targetTrait: '!Daemonic,!Machine',
          damageBonus: 3
        }
      ]
    }
  },
  {
    id: 'dumdum',
    name: 'Dumdum Bullets',
    rulebook: 'rogue-trader-core',
    availability: 'Scarce',
    compatibleWeapons: ['stub-revolver', 'stub-auto', 'hand-cannon'],
    effects: {
      damageModifier: 2,
      doubleArmour: true
    }
  },
  {
    id: 'expander-rounds',
    name: 'Expander Rounds',
    rulebook: 'rogue-trader-core',
    availability: 'Scarce',
    compatibleWeapons: ['stub-revolver', 'stub-auto', 'autopistol', 'autogun'],
    effects: {
      damageModifier: 1,
      penetrationModifier: { type: 'add', value: 1 }
    }
  },
  {
    id: 'explosive-arrowsquarrels',
    name: 'Explosive Arrows/Quarrels',
    rulebook: 'rogue-trader-core',
    availability: 'Scarce',
    compatibleWeapons: ['bow', 'crossbow', 'hand-bow'],
    effects: {
      attackModifier: -10,
      damageTypeOverride: 'Explosive',
      qualitiesRemoved: ['Primitive']
    }
  },
  {
    id: 'hot-shot-charge',
    name: 'Hot-Shot Charge Pack',
    rulebook: 'rogue-trader-core',
    availability: 'Scarce',
    compatibleWeapons: ['laspistol', 'lascarbine-locke', 'lasgun', 'long-las'],
    effects: {
      damageModifier: 1,
      penetrationModifier: { type: 'set', value: 4 },
      qualitiesAdded: ['Tearing'],
      qualitiesRemoved: ['Reliable'],
      clipOverride: 1
    }
  },
  {
    id: 'inferno-shells',
    name: 'Inferno Shells',
    rulebook: 'rogue-trader-core',
    availability: 'Rare',
    compatibleWeapons: [
      'shotgun',
      'pump-action-shotgun',
      'combat-shotgun',
      'bolt-pistol',
      'boltgun',
      'heavy-bolter'
    ],
    effects: {
      conditionalEffects: [
        {
          condition: 'Target hit',
          effect: 'Target must make Agility Test or catch on fire'
        }
      ]
    }
  },
  {
    id: 'man-stopper-bullets',
    name: 'Man-Stopper Bullets',
    rulebook: 'rogue-trader-core',
    availability: 'Scarce',
    compatibleWeapons: [
      'stub-revolver',
      'stub-auto',
      'hand-cannon',
      'hunting-rifle',
      'autopistol',
      'autogun'
    ],
    effects: {
      penetrationModifier: { type: 'set', value: 3 }
    }
  },
  {
    id: 'tempest-bolt-shells',
    name: 'Tempest Bolt Shells',
    rulebook: 'rogue-trader-core',
    availability: 'Near Unique',
    compatibleWeapons: ['bolt-pistol', 'boltgun', 'heavy-bolter'],
    effects: {
      damageTypeOverride: 'Energy',
      qualitiesAdded: ['Shocking'],
      conditionalEffects: [
        {
          condition: 'Target has Machine Trait',
          effect: '+3 Damage',
          targetTrait: 'Machine',
          damageBonus: 3
        }
      ]
    }
  }
];
